<template>
  <div class="w-full text-white bg-black">

    <!-- ao vivo -->
    <section class="px-6 md:px-20 py-10 md:mt-10">
      <h2 class="text-xl md:text-2xl font-semibold mb-4 uppercase text-start">
        AO VIVO AGORA
      </h2>

      <div v-if="lastEvents?.live?.length">
        <Carrossel>
          <CardEventoPreview
            v-for="(item, index) in lastEvents?.live"
            :key="index"
            :image="item.banner !== null && item.banner !== '[]' ? fileUrl + item.banner : banner"
            :title="item.title"
            :date="formatDate(item.date)"
            :live="item.is_live"
            @click="watchEvent(item)"
          />
        </Carrossel>
      </div>
      <div class="w-full py-3" v-else>
        Em breve...
      </div>
    </section>

    <!-- ULTIMOS EVENTOS -->
    <section class="px-6 md:px-20 py-10">
      <h2 class="text-xl md:text-2xl font-semibold mb-4 uppercase text-start">
        ULTIMOS EVENTOS
      </h2>

      <div v-if="lastEvents?.lasts?.length">
        <Carrossel>
          <CardEventoPreview
            v-for="(item, index) in lastEvents?.lasts"
            :key="index"
            :image="item.banner !== null && item.banner !== '[]' ? fileUrl + item.banner : banner"
            :title="item.title"
            :date="formatDate(item.date)"
            @click="watchEvent(item)"
          />
        </Carrossel>
      </div>
      <div class="w-full py-3" v-else>
        Em breve...
      </div>
    </section>

    <!-- MAIS ANTIGOS -->
    <section class="px-6 md:px-20 py-10">
      <h2 class="text-xl md:text-2xl font-semibold mb-4 uppercase text-start">
        EVENTOS MAIS ANTIGOS
      </h2>

      <div v-if="lastEvents?.older?.length">
        <Carrossel>
          <CardEventoPreview
            v-for="(item, index) in lastEvents?.older"
            :key="index"
            :image="item.banner !== null && item.banner !== '[]' ? fileUrl + item.banner : banner"
            :title="item.title"
            :date="formatDate(item.date)"
            :live="item.is_live"
            @click="watchEvent(item)"
          />
        </Carrossel>
      </div>
      <div class="w-full py-3" v-else>
        Ainda não há eventos antigos
      </div>
    </section>

  </div>
</template>

<script setup>
import { onBeforeMount, markRaw, computed } from 'vue'

import { dataShared } from '@/shared/store'
import CardEventoPreview from '../auth/components/CardEventoPreview.vue'
import { useRoute } from 'vue-router'
import router from '@/router'
import SharedService from '@/shared/services/shared'

import { formatDate } from '@/utils/formaters'
import moment from 'moment'
import 'moment/locale/pt-br'
import Carrossel from '../auth/components/_partials/Carrossel.vue'

const banner = 'https://www.ufc.com.br/images/styles/background_image_xl/s3/2025-04/051025-ufc-315-muhammad-vs-della-maddalena-EVENT-ART.jpg?h=d1cb525d&itok=hvnPcPlX%201x,%20https://ufc.com/images/styles/background_image_xl_2x/s3/2025-04/051025-ufc-315-muhammad-vs-della-maddalena-EVENT-ART.jpg'
const route = useRoute()
const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
const customerId = computed(() => dataShared.getters.getCIdByCookie)
const mainEvent = computed(() => dataShared.getters.getMainEvent)
const lastEvents = computed(() => dataShared.getters.getLives)

function setComponentActive (value) {
  dataShared.dispatch('setComponentActive', markRaw(value))
}

async function watchEvent (event) {
  // storeApp.state.loading = true
  dataShared.dispatch('activeLoading')

  await SharedService.watchEventById(event?.id)
    .then(res => {
      dataShared.dispatch('setEventToPurchase', event?.id)
      dataShared.dispatch('desactiveLoading')

      if (res.data.success == false) {
        return router.push(`/purchase/${event?.id}/event`)
      }

      dataShared.dispatch('setLiveActive', event)
      router.push(`/live/${event?.id}`)
    }).catch(err => {
      dataShared.dispatch('desactiveLoading')
      console.log(err)
    })
}

async function getLIves () {
  dataShared.dispatch('activeLoading')

  await SharedService.getLives()
    .then(res => {
      dataShared.dispatch('desactiveLoading')
      dataShared.dispatch('setAllLives', res.data)

      // Promise.all([
      //   checkIfCustomerHasAccessToEvent()
      // ])
    }).catch(err => {
      if (err.response.data.error === 401) {
        toast(
          'Aviso',
          'Sua sessão expirou, faça login',
          'error'
        )
        router.push('/auth')
      }
    })
}

function formatDateFull (dateString) {
  return moment(dateString).format('dddd, D [de] MMMM [de] YYYY')
}

onBeforeMount(() => {
  window.scrollTo(0, 0)
  Promise.all([
    getLIves()
  ])
})
</script>

<style lang="scss" scoped>
p {
  margin: 10px 0;
}
</style>
